// 写信页面
const AddEmail = {
  state: {
    // c3环境im吉信模块发送过来的收件人信息
    imToRecAll: []
  },

  mutations: {
    // 更新im吉信发送过来的收件人信息
    updateImToRecAll(state, payload) {
      state.imToRecAll = payload
    }
  },
  getters: {}
}

export default AddEmail



// WEBPACK FOOTER //
// ./src/store/addEmail.js